export default "__VITE_ASSET__ffc5b5e7__"